module.exports = __webpack_public_path__ + "static/media/fruitVeggies.7923a6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fruitVeggies.png
// module id = 646
// module chunks = 0